import React, { useEffect, useMemo, useState, type KeyboardEvent } from 'react';
import Select from 'react-select';
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import allLocales from '@fullcalendar/core/locales-all'
import listPlugin from '@fullcalendar/list'
import { ItemCalendar } from './components/itemCalendar';
import { getServicesAll } from '../../../../services/servicesService';
import { Loading } from '../../../components/Loadings/loading';
import './styles.css'
import layoutStyles from '../../../components/CalendarServicesLayout/calendarServicesLayout.module.css';
import { useAuth } from '../../../../modules/auth';
import { ModalDetailsOS } from '../ScreenServices/components/ModalDetailsOS';
import { getReportServicesAll } from '../../../../services/reportService';
import { ModalRequestService } from '../ScreenServices/components/ModalDetailsRequestService';
import { getplantsAll } from '../../../../services/plantsService';
import { getUnitBranchAllSimple } from '../../../../services/unitBranchService';
import { getCollaboratosAll } from '../../../../services/collaboratorsService';
import { getClientAll } from '../../../../services/clientService';
import { useToast } from '../../../components/Toats';
import useSize from '../../../../hooks/useSize';
import { PaginationTablePlants } from '../../../dashboard/TablePlants/components/Pagination';
import { useReactSelectStyles } from '../../../subscriptions/core/reactSelectTheme';

const handleSelectBackspaceKey = (e: KeyboardEvent) => {
  if (e.key === 'Backspace') {
    e.stopPropagation();
  }
};

type Props = {
    refreshPage : boolean; 
    setRefreshPage: any;
}

type Paginations = {
  page: number,
  limit: number,
  total: number,
  qtdPages: number
}

type SetPaginations = {
  start: number;
  end: number;
}

export function CalendarServices({refreshPage} : Props) {
    const [services, setServices] = useState<any[]>([]);
    const [reportServices, setReportServices] = useState<any[]>([]);
    const [itensCalendar, setItensCalendar] = useState<any[]>([]);
    const [plants, setPlants] = useState<any[]>([]);
    const [collaboratos, setCollaboratos] = useState<any[]>([]);
    const [clients, setClients] = useState<any[]>([]);
    const [unitBranchs, setUnitBranchs] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingPlants, setLoadingPlants] = useState<boolean>(false);
    const [loadingCollaborators, setLoadingCollaborators] = useState<boolean>(false);
    const [loadingClients, setLoadingClients] = useState<boolean>(false);
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false)
    const [showModalConfirmReport, setShowModalConfirmReport] = useState<boolean>(false)
    const [myService, setMyService] = useState<any | null>(null);
    const [myReportService, setMyReportService] = useState<any | null>(null);
    const [filterServices, setFilterServices] = useState<string>("1");

    const [filterPlant, setFilterPlant] = useState<string>("");
    const [filterColaborator, setFilterColaborator] = useState<string>("");
    const [filterClient, setFilterClient] = useState<string>("");
    const [filterUnitBracnh, setFilterUnitBracnh] = useState<string>("");

    const user = useAuth();
    const { toggleToast } = useToast();

    const { width } = useSize();
    const isMobile = width < 992;
    const selectStyles = useReactSelectStyles();

    const calendarToolbar = useMemo(
      () => ({
        left: isMobile ? 'prev,next' : 'prev,next today',
        center: 'title',
        right: isMobile
          ? user.currentUser?.role.slug !== 'CLIENTE'
            ? 'listWeek,dayGridMonth'
            : 'listWeek'
          : user.currentUser?.role.slug !== 'CLIENTE'
            ? 'dayGridMonth,timeGridDay,listWeek'
            : 'dayGridMonth, listWeek',
      }),
      [isMobile, user.currentUser?.role.slug]
    );

    const plantOptions = useMemo(
      () =>
        plants.map((plant: any) => ({
          value: plant.id,
          label: plant.name,
        })),
      [plants]
    );

    const selectedPlantOption = useMemo(
      () => plantOptions.find((option) => option.value === filterPlant) || null,
      [plantOptions, filterPlant]
    );

    const userOptions = useMemo(
      () =>
        collaboratos.map((collaborator: any) => ({
          value: collaborator.id,
          label: collaborator.name,
        })),
      [collaboratos]
    );

    const selectedUserOption = useMemo(
      () => userOptions.find((option) => option.value === filterColaborator) || null,
      [userOptions, filterColaborator]
    );

    const clientOptions = useMemo(
      () =>
        clients.map((client: any) => ({
          value: client.id,
          label: client.nameResponsible,
        })),
      [clients]
    );

    const selectedClientOption = useMemo(
      () => clientOptions.find((option) => option.value === filterClient) || null,
      [clientOptions, filterClient]
    );

    const [pagination, setPagination] = useState<Paginations>({
      page: 1,
      limit: 25,
      total: 0,
      qtdPages: 1
    });
  
    const [qtd, setQtd] = useState<SetPaginations>({
      start: 0,
      end: 25,
    });

    const getServices = async () => {
        try {
          setLoading(true)
          const myServices = await getServicesAll(
            "", 
            filterPlant ? filterPlant : "", 
            filterUnitBracnh ? filterUnitBracnh : "", 
            filterColaborator ? filterColaborator : "",
            "",
            "",
            filterClient ? filterClient : ""
          )
          
          if(myServices && myServices.length > 0){
            const list_itens = myServices.map((myServiceOne: any) => {
              const myDate = {
                title: myServiceOne.title,
                start: myServiceOne.dateInit ? myServiceOne.dateInit : new Date(),
                end: myServiceOne.dateEnd ? myServiceOne.dateEnd : new Date(),
                //id: myServiceOne.id,
                plant: myServiceOne.plant ? myServiceOne.plant.name : "Usina não identificada.",
                status: myServiceOne.status ? myServiceOne.status : "Status não identificado.", 
                myId: myServiceOne.id ? myServiceOne.id : null,
                type: "O.S"
              }
              return myDate;
            })
            setServices(list_itens)
            setItensCalendar(list_itens)
          }else{
            setServices([])
            setItensCalendar([])
          }
    
        } catch (error) {
          console.log(error)
          toggleToast("Erro ao buscar os serviços. ", "error")
    
        }finally{
          setLoading(false)
        }
    }

    const getReportServices = async () => {
      try {
        setLoading(true)
        const myReportServices = await getReportServicesAll(
          filterPlant ? filterPlant : "", 
          filterUnitBracnh ? filterUnitBracnh : ""
        )
        //setServices(myReportServices)
        
        if(myReportServices && myReportServices.length > 0){
          const filteredReportServices = filterClient
            ? myReportServices.filter((reportService: any) => reportService.client?.id === filterClient)
            : myReportServices;

          const list_itens = filteredReportServices.map((myReportService: any) => {
            const myDate = {
              title: myReportService.description              ,
              start: myReportService.created_at ? myReportService.created_at : new Date(),
              //id: myReportService.id,
              plant: myReportService.plant ? myReportService.plant.name : "Usina não identificada.",
              status: myReportService.status ? myReportService.status : "Status não identificado.", 
              myId: myReportService.id ? myReportService.id : null,
              type: "S.S"
            }
            return myDate;
          })
          setReportServices(list_itens)
          setItensCalendar((prevItensCalendar) => [
            ...prevItensCalendar,
            ...list_itens,
          ]);
        }else{
          setReportServices([])
          setItensCalendar((prevItensCalendar) => [
            ...prevItensCalendar,
            ...[],
          ]);
        }
  
      } catch (error) {
        console.log(error)
        toggleToast("Erro ao buscar os serviços. ", "error")
  
      }finally{
        setLoading(false)
      }
  }

  const getPlants = async () => {
    try {
      setLoadingPlants(true)
      const myPlants = await getplantsAll()
      setPlants(myPlants)

    } catch (error) {
      console.log(error)
    }finally{
      setLoadingPlants(false)
    }
  }

  const getUnitBranch = async () => {
    try {
      const unitBranch = await getUnitBranchAllSimple()
      setUnitBranchs(unitBranch)

    } catch (error) {
      console.log(error)
      //toggleToast("Erro ao buscar as unidades filiais. ", "error")
    }
  }

  const getCollaboratos = async () => {
    try {
      setLoadingCollaborators(true)
      const myCollaborators = await getCollaboratosAll()
      setCollaboratos(myCollaborators)

    } catch (error) {
      console.log(error)
      toggleToast("Erro ao buscar os collaboradores!", "error")
    }finally{
      setLoadingCollaborators(false)
    }
}

  const getClients = async () => {
    try {
      setLoadingClients(true)
      const myClients = await getClientAll(
        filterUnitBracnh ? filterUnitBracnh : ""
      )
      setClients(Array.isArray(myClients) ? myClients : myClients ? [myClients] : [])
    } catch (error) {
      console.log(error)
      toggleToast("Erro ao buscar os clientes!", "error")
    } finally {
      setLoadingClients(false)
    }
  }


  const handleEventClick = (evt: any) => {
    if(evt.event._def.extendedProps.type === "O.S"){
      setMyService({
        id: evt.event._def.extendedProps.myId
      })
      setShowModalConfirm(true)
    }else if(evt.event._def.extendedProps.type === "S.S"){
      setMyReportService({id: evt.event._def.extendedProps.myId})
      setShowModalConfirmReport(true)
    }
      
  }

  const refresh = () => {
    const fetch = async() => {
      await getServices()
      await getReportServices()
      await getPlants()
      await getUnitBranch()
      await getCollaboratos()
      await getClients()
    }
    fetch() 
  }

  useEffect(() => {
    const fetch = async() => {
      await getServices()
      await getReportServices()
      await getPlants()
      await getUnitBranch()
      await getCollaboratos()
      await getClients()
    }
    fetch() 
  }, [])

  useEffect(() => {
    const fetch = async() => {
      await getServices()
      await getReportServices()
    }
    fetch() 
  }, [
    filterPlant, 
    filterColaborator, 
    filterUnitBracnh,
    filterClient,
  ])

  useEffect(() => {
    if (user.currentUser?.role.slug === 'CLIENTE') {
      return
    }
    getClients()
  }, [filterUnitBracnh])

  useEffect(() => {
      getServices()
  }, [refreshPage])



  // if (loading || loadingReportServices || loadingPlants) {
  //     return (
  //       <div style={{display: 'flex', justifyContent: 'center', height: '15rem', alignItems: 'center'}}>
  //         <Loading myClass='spinner-border' style={{width: '3rem', height: '3rem'}}/>
  //       </div>
  //     );
  // }

  return (
    <div className={layoutStyles.calendarRoot}>
        <div className={layoutStyles.calendarShell}>
          <div className={layoutStyles.calendarHeader}>
            <div className={layoutStyles.calendarFiltersWrap}>
              <div className={layoutStyles.calendarFilters}>
                <div className={layoutStyles.calendarFilterGroup}>
                  <div className={layoutStyles.filterField}>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span>O.S / S.S: </span>
                    </label>
                    <select
                      className='form-select form-select-solid'
                      data-kt-select2='true'
                      data-placeholder='Select option'
                      data-allow-clear='true'
                      value={filterServices}
                      onChange={(event) => {setFilterServices(event.target.value)}}
                    >
                      <option value={'1'}>Todos</option>
                      <option value={'2'}>Ordem de Serviço (O.S)</option>
                      <option value={'3'}>Solicitações de Serviço (S.S)</option>
                    </select>
                  </div>

                  <div className={layoutStyles.filterField}>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span>Usina: </span>
                    </label>
                    <Select
                      options={plantOptions}
                      value={selectedPlantOption}
                      onChange={(option) => setFilterPlant(option?.value?.toString() ?? '')}
                      onKeyDown={handleSelectBackspaceKey}
                      placeholder='Todas as usinas'
                      isLoading={loadingPlants}
                      isSearchable
                      isClearable
                      noOptionsMessage={() => 'Nenhuma usina encontrada'}
                      loadingMessage={() => 'Carregando...'}
                      className='react-select-container'
                      classNamePrefix='react-select'
                      styles={selectStyles}
                    />
                  </div>
                </div>
 
                <div className={layoutStyles.calendarFilterGroup}>
                  <div className={layoutStyles.filterField}>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span>Filial: </span>
                    </label>
                    <select
                      className='form-select form-select-solid'
                      data-kt-select2='true'
                      data-placeholder='Select option'
                      data-allow-clear='true'
                      value={filterUnitBracnh}
                      onChange={(event) => {setFilterUnitBracnh((event.target.value).toString())}}
                    >
                      <option value={''}>Todos</option>
                      {unitBranchs && unitBranchs.map((unitBranch: any) => {
                        return (
                          <option key={unitBranch.id} value={unitBranch.id}>{unitBranch.companyName}</option>
                        )
                      })}
                    </select>
                  </div>

                  <div className={layoutStyles.filterField}>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span>Usuário: </span>
                    </label>
                    <Select
                      options={userOptions}
                      value={selectedUserOption}
                      onChange={(option) => setFilterColaborator(option?.value?.toString() ?? '')}
                      onKeyDown={handleSelectBackspaceKey}
                      placeholder='Todos os usuários'
                      isLoading={loadingCollaborators}
                      isSearchable
                      isClearable
                      isDisabled={filterServices === '3'}
                      noOptionsMessage={() => 'Nenhum usuário encontrado'}
                      loadingMessage={() => 'Carregando...'}
                      className='react-select-container'
                      classNamePrefix='react-select'
                      styles={selectStyles}
                    />
                  </div>

                  {user.currentUser?.role.slug !== 'CLIENTE' && (
                  <div className={layoutStyles.filterField}>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span>Cliente: </span>
                    </label>
                    <Select
                      options={clientOptions}
                      value={selectedClientOption}
                      onChange={(option) => setFilterClient(option?.value?.toString() ?? '')}
                      onKeyDown={handleSelectBackspaceKey}
                      placeholder='Todos os clientes'
                      isLoading={loadingClients}
                      isSearchable
                      isClearable
                      noOptionsMessage={() => 'Nenhum cliente encontrado'}
                      loadingMessage={() => 'Carregando...'}
                      className='react-select-container'
                      classNamePrefix='react-select'
                      styles={selectStyles}
                    />
                  </div>
                  )}
                </div>
                
              </div>
            </div>
          </div>

          <div className={layoutStyles.calendarPanel}>
              <FullCalendar
                  key={isMobile ? 'calendar-mobile' : 'calendar-desktop'}
                  plugins={user.currentUser?.role.slug !== "CLIENTE" ? [dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin] : [dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin]}
                  locales={allLocales} 
                  locale={'pt-br'}
                  initialView={isMobile ? 'listWeek' : 'dayGridMonth'}
                  headerToolbar={calendarToolbar}
                  eventClick={handleEventClick}
                  eventContent={ItemCalendar}

                  events={
                    filterServices === '1' 
                    ? 
                    itensCalendar && itensCalendar.length > 0 ? 
                    itensCalendar.map((itemCalendar) => {
                          return {
                              title: itemCalendar.title,
                              start: itemCalendar.start ? itemCalendar.start : new Date(),
                              end: itemCalendar.end ? itemCalendar.end : null,
                              //id: itemCalendar.id,
                              plant: itemCalendar.plant ? itemCalendar.plant : "Usina não identificada.",
                              type: itemCalendar.type ? itemCalendar.type : "",
                              status: itemCalendar.status ? itemCalendar.status : "Status não identificado.", 
                              myId: itemCalendar.myId ? itemCalendar.myId : null
                          }
                      })    
                      : [{}]
                    :
                    filterServices === '2'
                    ?
                    services && services.length > 0 ? 
                    services.map((itemCalendar) => {
                          return {
                              title: itemCalendar.title,
                              start: itemCalendar.start ? itemCalendar.start : new Date(),
                              end: itemCalendar.end ? itemCalendar.end : null,
                              //id: itemCalendar.id,
                              plant: itemCalendar.plant ? itemCalendar.plant : "Usina não identificada.",
                              type: itemCalendar.type ? itemCalendar.type : "",
                              status: itemCalendar.status ? itemCalendar.status : "Status não identificado.", 
                              myId: itemCalendar.myId ? itemCalendar.myId : null
                          }
                      })    
                      : [{}]
                    :
                    filterServices === '3'
                    ?
                    reportServices && reportServices.length > 0 ? 
                    reportServices.map((itemCalendar) => {
                          return {
                              title: itemCalendar.title,
                              start: itemCalendar.start ? itemCalendar.start : new Date(),
                              end: itemCalendar.end ? itemCalendar.end : null,
                              //id: itemCalendar.id,
                              plant: itemCalendar.plant ? itemCalendar.plant : "Usina não identificada.",
                              type: itemCalendar.type ? itemCalendar.type : "",
                              status: itemCalendar.status ? itemCalendar.status : "Status não identificado.", 
                              myId: itemCalendar.myId ? itemCalendar.myId : null
                          }
                      })    
                      : [{}]
                    :
                    [{}] 
                  }

                  // events={[
                  //     { title: 'event 1', start: new Date() },
                  //     { title: 'event 2', start: new Date() }
                  // ]}
              />
          </div>
        </div>

        <div className={`card-footer pt-0 pb-2 ${layoutStyles.calendarFooter}`}>
          <PaginationTablePlants 
            pagination={pagination}
            setPagination={setPagination}
            qtd={qtd}
          />
        </div>

        <ModalRequestService 
          show={showModalConfirmReport}
          data={myReportService}
          id={myReportService ? myReportService.id : undefined} 
          handleClose={() => {
            setMyReportService(null)
            setShowModalConfirmReport(false)
            refresh()
          }} 
        />


        <ModalDetailsOS
          show={showModalConfirm}
          data={myService}
          id={myService ? myService.id : undefined} 
          handleClose={() => {
            setMyService(null)
            setShowModalConfirm(false)
            refresh()
          }} 
        />

    </div>
  );
}